import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { TenantFormData } from "@/types/tenant";

interface BillingInfoStepProps {
  formData: TenantFormData;
  updateFormData: (updates: Partial<TenantFormData>) => void;
  errors: Record<string, string>;
}

export function BillingInfoStep({ formData, updateFormData, errors }: BillingInfoStepProps) {
  const handleSameAsPrimaryChange = (checked: boolean) => {
    updateFormData({ 
      billing_same_as_primary: checked,
      billing_contact_name: checked ? "" : formData.billing_contact_name,
      billing_contact_email: checked ? "" : formData.billing_contact_email,
    });
  };

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <h2 className="text-xl font-semibold">Billing Contact</h2>
        <p className="text-muted-foreground">
          Who should receive billing and invoice communications?
        </p>
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox
          id="billing_same_as_primary"
          checked={formData.billing_same_as_primary}
          onCheckedChange={handleSameAsPrimaryChange}
        />
        <Label htmlFor="billing_same_as_primary" className="cursor-pointer">
          Same as primary contact
        </Label>
      </div>

      {!formData.billing_same_as_primary && (
        <div className="grid gap-4 animate-in fade-in-50 duration-200">
          <div className="space-y-2">
            <Label htmlFor="billing_contact_name">Billing Contact Name</Label>
            <Input
              id="billing_contact_name"
              placeholder="Enter billing contact name"
              value={formData.billing_contact_name || ""}
              onChange={(e) => updateFormData({ billing_contact_name: e.target.value })}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="billing_contact_email">Billing Contact Email *</Label>
            <Input
              id="billing_contact_email"
              type="email"
              placeholder="billing@example.com"
              value={formData.billing_contact_email || ""}
              onChange={(e) => updateFormData({ billing_contact_email: e.target.value })}
              className={errors.billing_contact_email ? "border-destructive" : ""}
            />
            {errors.billing_contact_email && (
              <p className="text-sm text-destructive">{errors.billing_contact_email}</p>
            )}
          </div>
        </div>
      )}

      {formData.billing_same_as_primary && (
        <div className="p-4 bg-muted/50 rounded-lg">
          <p className="text-sm text-muted-foreground">
            Billing communications will be sent to <span className="font-medium text-foreground">{formData.email || "the primary email address"}</span>
          </p>
        </div>
      )}
    </div>
  );
}
